/**
 * Updates the user's networth.
 *
 * This is currently updating randomly. Eventually, this will update based on the current log/question.
 *
 * Expects:
 *  - networth = the user's current networth
 *  - setNetworth = the state setter for networth
 *  - age = the user's current age
 *
 * Returns:
 *  - true if successful
 */
const updateNetworth = async (networth, setNetworth, age) => {
	// Random values for user's over 18
	const randValuesAdult = [
		102,
		1003,
		121,
		-902,
		-5677,
		96,
		5,
		-10,
		-98,
		22,
		-22,
	];

	// Random values for user under 18
	const randValuesChild = [5, 3, 2, 7, 10, 22, -5, -19, -9, -3, 1, -1];

	if (age < 18) {
		let newNetworth =
			networth + Math.floor(Math.random() * randValuesChild.length);
		setNetworth(newNetworth);

		console.log(`AGE: ${age} net: ${newNetworth}`);

		return true;
	} else {
		let newNetworth =
			networth + Math.floor(Math.random() * randValuesAdult.length);

		setNetworth(newNetworth);

		console.log(`AGE: ${age} net: ${newNetworth}`);
		return true;
	}
};

export default updateNetworth;
